































import { VMenu } from 'vuetify/lib'
import BaseIcon from './BaseIcon.vue'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  components: {
    VMenu,
    BaseIcon
  }
})
